import { create } from "zustand";
import { persist } from "zustand/middleware";
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "../core/i18n";
import { getLanguageFromPath } from "../utils/urlUtils";

interface LanguageState {
  currentLanguage: SupportedLanguage;
  setLanguage: (language: SupportedLanguage) => void;
  getCurrentLanguageInfo: () => (typeof SUPPORTED_LANGUAGES)[SupportedLanguage];
}

const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      currentLanguage:
        typeof window !== "undefined" ? getLanguageFromPath() : "en",
      setLanguage: (language) => set({ currentLanguage: language }),
      getCurrentLanguageInfo: () => {
        const { currentLanguage } = get();
        return SUPPORTED_LANGUAGES[currentLanguage] || SUPPORTED_LANGUAGES.en;
      },
    }),
    {
      name: "language-storage", // unique name for localStorage key
      merge: (persistedState, currentState) => {
        const merged = {
          ...currentState,
          ...(persistedState as Partial<LanguageState>),
        };
        const urlLanguage = getLanguageFromPath();
        const pathSegment = window.location.pathname
          .split("/")
          .filter(Boolean)[0];

        if (pathSegment && pathSegment in SUPPORTED_LANGUAGES) {
          merged.currentLanguage = urlLanguage;
        }

        return merged;
      },
    },
  ),
);

export default useLanguageStore;
